var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-board"},_vm._l((_vm.items),function(item,index){return _c('div',{key:("item" + index),staticClass:"base-board__item"},[_vm._t("board-item",null,{"item":item,"itemIndex":index})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }